export default function processWalletAdrress(
	text: string,
	partLenght: number,
	shortDevider = false,
) {
	const firstPart = text.slice(0, partLenght);
	const secondPart = text.slice(-partLenght);
	return firstPart + `${shortDevider ? '..' : '...'}` + secondPart;
}
